import { render, staticRenderFns } from "./CreateJournal.vue?vue&type=template&id=10af29ed&scoped=true"
import script from "./CreateJournal.vue?vue&type=script&lang=js"
export * from "./CreateJournal.vue?vue&type=script&lang=js"
import style0 from "./CreateJournal.vue?vue&type=style&index=0&id=10af29ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af29ed",
  null
  
)

export default component.exports